import styled from 'styled-components';

// export type BoxProps = {
//   children: React.ReactNode,
//   id: string,
// };

export const PureBox = ({ children, id, ...props }) => (
  <div id={id} {...props}>
    {children}
  </div>
);

export const Box = styled(PureBox)`
  border-radius: 4px;
  border: 1px solid #ddd;
  overflow: hidden;
`;
